<template>
  <!-- Se tiene que poder agregar mas vehiculo -->
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form" v-if="!loading">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ModelProcedure.UnitFullName}}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-tittle">
              <p>¿TIENE VEHÍCULOS PARA REGISTRAR?</p>
              <div class="demo">
                <input type="radio" :value="true" v-model="hasVehicles" />
                <label>SI</label>
              </div>
              <div class="demo">
                <input type="radio" :value="false" v-model="hasVehicles" />
                <label>NO</label>
              </div>
            </div>

            <template v-if="hasVehicles">
              <div class="empadronamiento__intro__main__form__container-header">
                <p>DATOS – VEHÍCULOS</p>
              </div>
              <p class="empadronamiento__form_header_info_text" style="text-align: justify;">
                Por favor, ingresá los datos requeridos con la información de cada uno de los vehículos. Para este paso es necesario contar con foto de la cédula verde o azul (frente y dorso) y, en el caso de que sea alquilado, el respectivo contrato de alquiler.
              </p>
              <fieldset v-for="(vehicle, i) in ModelProcedure.Vehicles" :key="i">
                <div class="empadronamiento__intro__main__form__container-tittle flex-between">
                  <p style="text-transform:uppercase;">Vehículo {{ i + 1 }} :</p>
                  <p class="delete" v-if="i > 0" @click="deleteVehicle(i)">Eliminar</p>
                </div>

                <base-input 
                  placeholder="Dominio *"
                  v-model="vehicle.Domain"
                  :invalid="$v.ModelProcedure.Vehicles.$each[i].Domain.$invalid && submitted" />

                <base-input 
                  placeholder="Marca *" 
                  v-model="vehicle.Brand" 
                  :invalid="$v.ModelProcedure.Vehicles.$each[i].Brand.$invalid && submitted" />
                
                <base-input 
                  placeholder="Modelo *" 
                  v-model="vehicle.Model" 
                  :invalid="$v.ModelProcedure.Vehicles.$each[i].Model.$invalid && submitted" />
                
                <base-input 
                  placeholder="Color *" 
                  v-model="vehicle.Color" 
                  :invalid="$v.ModelProcedure.Vehicles.$each[i].Color.$invalid && submitted" />
                
                <select
                  class="empadronamiento__intro__main__form__container-form"
                  v-model="vehicle.RelatedPersonUniqueCode" 
                  :class="{'has-error': $v.ModelProcedure.Vehicles.$each[i].RelatedPersonUniqueCode.$invalid && submitted}"
                >
                  <option value="" disabled ref="placeholder" selected>Titular relacionado *</option>
                  <option v-for="(relatedPerson, i) in ListRelatedPerson" :value="relatedPerson.Id" :key="i+1">{{relatedPerson.FullName}}</option>
                </select>
                <div v-if="vehicle.RelatedPersonUniqueCode != null && vehicle.RelatedPersonUniqueCode != ''" class="empadronamiento__intro__main__form__container-tittle flex-between">
                  <p v-if="ListRelatedPerson.find(relatedPerson => relatedPerson.Id === vehicle.RelatedPersonUniqueCode)" style="text-transform: uppercase;">Cédula de {{ListRelatedPerson.find(relatedPerson => relatedPerson.Id === vehicle.RelatedPersonUniqueCode).FullName}}</p>
                </div> 

                <base-file-upload
                  v-if="enumIdFront != null"
                  :keyIndex="i"
                  :attach="enumIdFront"
                  :showTooltipActive="showTooltipActive"
                  @changeTooltipActive="showTooltipActive = $event"
                  @change="uploadFile"
                  @clearUpload="clearFile"
                  :modelProp="getAttachModelPropName(enumIdFront)"
                  :state="vehicle[getAttachModelPropName(enumIdFront)]"
                  :invalid="$v.ModelProcedure.Vehicles.$each[i][getAttachModelPropName(enumIdFront)].$invalid && submitted"
                  :previewURL="getAttachPreviewURL(enumIdFront,i)"
                  style="z-index:1;"
                />
                <base-file-upload
                  v-if="enumIdBack != null"
                  :keyIndex="i"
                  :attach="enumIdBack"
                  :showTooltipActive="showTooltipActive"
                  @changeTooltipActive="showTooltipActive = $event"
                  @change="uploadFile"
                  @clearUpload="clearFile"
                  :modelProp="getAttachModelPropName(enumIdBack)"
                  :state="vehicle[getAttachModelPropName(enumIdBack)]"
                  :invalid="$v.ModelProcedure.Vehicles.$each[i][getAttachModelPropName(enumIdBack)].$invalid && submitted"
                  :previewURL="getAttachPreviewURL(enumIdBack,i)"
                  style="z-index:1;"
                />
                <div v-if="enumRentContract != null" class="empadronamiento__intro__main__form__container-tittle">
                  <p style="text-transform: uppercase;">¿es alquilado? </p>
                  <div class="demo">
                    <input type="radio" :value="true" v-model="isRented" />
                    <label>SI</label>
                  </div>
                  <div class="demo">
                    <input type="radio" :value="false" v-model="isRented" />
                    <label>NO</label>
                  </div>
                </div> 
                <base-file-upload
                  v-if="isRented && enumRentContract != null"
                  :keyIndex="i"
                  :attach="enumRentContract"
                  :showTooltipActive="showTooltipActive"
                  @changeTooltipActive="showTooltipActive = $event"
                  @change="uploadFile"
                  @clearUpload="clearFile"
                  :modelProp="getAttachModelPropName(enumRentContract)"
                  :state="vehicle[getAttachModelPropName(enumRentContract)]"
                  :invalid="false"
                  :previewURL="getAttachPreviewURL(enumRentContract,i)"
                  style="z-index:1;"
                />
              </fieldset>
            </template>      
          </fieldset>

          <base-add-section v-if="hasVehicles" label="Agregar vehículo" @click="addVehicle" />
        </form>
        <div class="empadronamiento__intro__button">
          <button-link back>
            <p>Volver</p>
          </button-link>
          <button v-if="!loadingForm" class="active" @click="sendVehiculos()">Continuar</button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
    <div v-if="showTooltipActive != ''" class="tooltip-background" @click="showTooltipActive = ''"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, not } from 'vuelidate/lib/validators'

export default {
  computed: {
    ...mapState({
      Enums: state => state.neighregistration.Enums,
      ModelProcedure: state => state.manageVecino.ModelProcedure,
      ListRelatedPerson: state => state.neighregistration.ListRelatedPerson
    }),
    enumIdFront () {
      if(this.Enums.ProcedureVehicleAttachType && !this.loading)
      {
        return this.Enums.ProcedureVehicleAttachType.find(att => att.Code == 'ProcedureVehicleAttachment.IdentificationCardFront');
      }
      return null;
    },
    enumIdBack () {
      if(this.Enums.ProcedureVehicleAttachType && !this.loading)
      {
        return this.Enums.ProcedureVehicleAttachType.find(att => att.Code == 'ProcedureVehicleAttachment.IdentificationCardBack');
      }
      return null;
    },
    enumRentContract () {
      if(this.Enums.ProcedureVehicleAttachType && !this.loading)
      {
        return this.Enums.ProcedureVehicleAttachType.find(att => att.Code == 'ProcedureVehicleAttachment.RentalContract');
      }      
      return null;
    }
  },
  data() {
    return {
      hasVehicles: false,
      loading: true,
      section: "VEHICLE",
      submitted: false,
      loadingForm : false,
      isRented : false,
      showTooltipActive: ''
    }
  },
  created() {
    const self = this
    if (self.ModelProcedure.Vehicles && self.ModelProcedure.Vehicles.length > 0) self.hasVehicles = true;
  },
  mounted() {
    const self = this
    if(!this.ModelProcedure.hasOwnProperty('UCode')) {
      this.$store.dispatch('getProcedure' , {
        ucode: this.$route.query.ucode
      }).then(() => {
        this.$store.dispatch("getEnums").then(()=> self.loading = false);
        if (self.ModelProcedure.Vehicles.length > 0) self.hasVehicles = true;
      })
    } else {
      this.$store.dispatch("getEnums").then(()=> self.loading = false);
    }
  },
  methods: {
    getAttachPreviewURL(attach,i){
      let attachId = null;
      attachId = this.ModelProcedure.Vehicles[i][this.getAttachModelPropName(attach)];
      let attachUrl = '';
      if(attachId != null)
      {
        attachUrl = `${process.env.VUE_APP_URL_API}/neighregistration/procedurevehicleattachment/preview/${attachId}`
      }
      return attachUrl
    },
    addVehicle() {
      this.$store.dispatch('addVehicle')
    },
    deleteVehicle(index) {
      this.$store.dispatch('removeVehicle', index)
    },
    getAttachModelPropName({ Name }) {
      const returnValue = this.$store.getters.findAttachPropByName(
        Name,
        this.section
      );
      return returnValue;
    },
    uploadFile({ file,  attachmentTypeId, modelProp, keyIndex }) {
      const self = this;
      const section = self.section;
      this.$store
        .dispatch("uploadFile", { file, attachmentTypeId, section })
        .then(res => (self.ModelProcedure.Vehicles[keyIndex][modelProp] = res));
    },
    clearFile({modelProp, keyIndex}) {
      const self = this;
      self.ModelProcedure.Vehicles[keyIndex][modelProp] = 0;
    },
    sendVehiculos () {
      const self = this;
      self.submitted = true;
      if (!this.isInvalidForm()) {
        if(!this.hasVehicles) this.ModelProcedure.Vehicles = [];
        self.loadingForm = true;
        this.$store.dispatch("updateProcedure", {
          model: this.ModelProcedure
        }).then(() => {
          self.$router.push(`/vecino/referencia?ucode=${self.$route.query.ucode}`);
        })
      }
      else
      {
        var element = document.querySelector(".empadronamiento__intro__main__form__container-item .has-error");
        if(element != null)
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest'}) 
      }
    },
    getAttachValidator(attach, i) {
      const propName = this.getAttachModelPropName(attach);
      return this.$v.ModelProcedure.Vehicles.$each[i][propName];
    },
    isInvalidForm() {
      let invalid;
      if (this.hasVehicles) {
        invalid = this.$v.ModelProcedure.Vehicles.$invalid
      } else {
        this.ModelProcedure.Vehicles = [];
        invalid = false
      }
      return invalid
    }
  },
  watch: {
    hasVehicles() {
      if (this.hasVehicles) {
        this.$store.dispatch('getRelatedPersons', {procedureCode: this.ModelProcedure.UCode})
        if (this.ModelProcedure.Vehicles.length == 0) this.addVehicle()
      }
    }
  },
  validations: {
    ModelProcedure: {
      Vehicles: {
        $each: {
          Domain: {
            required
          },
          Brand: {
            required
          },
          Model: {
            required,
            not: not(model => model === 0)
          },
          Color: {
            required
          },
          RelatedPersonUniqueCode: {
            required
          },
          IdentificationCardFront: {
            required,
            not: not(model => model === 0)
          },
          IdentificationCardBack: {
            required,
            not: not(model => model === 0)
          }
        }
      }
    }
  }
}
</script>

<style>

</style>